import React from 'react'
import { Col, Label, Input, Row as RowNormal } from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'
import clone from 'lodash/clone'
import shortid from 'shortid'
import NumberFormat from 'react-number-format'
import { StickyTable, Row, Cell } from 'react-sticky-table'
import 'react-sticky-table/dist/react-sticky-table.css'
import TrashDefault from '../../../../static/images/trash-default.svg'
import TrashHover from '../../../../static/images/trash-hover.svg'
import WarningIcon from '../../../../static/images/warning-icon.svg'
import { FONTS } from '../../../../constants'
import moment from '../../../../lib/moment.js'

export default class ResourceCostTable extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)) return false
    return true
  }

  filterResource = (element) => {
    const search_resource = get(this.props, 'search_resource', '')
    const filter_lob = get(this.props, 'filter_lob', [])
    const filter_module = get(this.props, 'filter_module', [])
    let isFilterSearch = false
    let isFilterLOB = false
    let isFilterModule = false
    if (search_resource !== '' && element) {
      const name = element.name.toLowerCase()
      const level = element.level.toLowerCase()
      const type = element.type.toLowerCase()
      const role = element.role.toLowerCase()
      isFilterSearch = type.includes(search_resource.toLowerCase())
      || role.includes(search_resource.toLowerCase())
      || name.includes(search_resource.toLowerCase())
      || level.includes(search_resource.toLowerCase())
    }
    if (filter_lob.length && element)  {
      const lob = element.lob
      isFilterLOB = filter_lob.includes(lob)
    }
    if (filter_module.length && element)  {
      const module = element.module
      isFilterModule = filter_module.includes(module)
    }
    let isNotFilter = search_resource === '' && !filter_lob.length && !filter_module.length
    return isFilterSearch || isFilterLOB || isFilterModule || isNotFilter
  }

  generateMonth = (start_date, end_date) => {
    const months = []
    if (start_date !== '' && end_date !== '') {
      while (moment(start_date).isSameOrBefore(moment(end_date), 'month')) {
        months.push({ year: moment(start_date).format('YYYY'), month: moment(start_date).format('MMMM') })
        start_date = moment(start_date).add(1, 'month')
      }
    }
    // const addedMonths = []
    // if (months.length < 15) {
    //   for (let i = 0; i < 15 - months.length; i++) {
    //     addedMonths.push({ year: '', month: '' })
    //   }
    // }
    return months
  }

  generateResource = (months, resource) => {
    const employees = get(this.props, 'employees', [])
    const newResources = []
    let newMonths = []
    for (let i = 0; i < resource.length; i++) {
      const temp_resource = clone(resource[i])
      const user = find(employees, {
        _id: resource[i].user_id,
      })
      let name = ''
      let level = ''
      let lob = '-'
      if (user) {
        name = `${user.first_name} ${user.last_name} (${user.nick_name})`
        level = user.level
        lob = user.lob
      }
      for (let j = 0; j < months.length; j++) {
        const temp = find(temp_resource.man_days, {
          month: `${months[j].year}-${moment().month(months[j].month).format('MM')}`,
        })
        if (temp === undefined) {
          newMonths.push({
            month: `${months[j].year}-${moment().month(months[j].month).format('MM')}`,
            days: 0,
          })
        } else newMonths.push(temp)
      }
      temp_resource.man_days = newMonths
      temp_resource.name = name
      temp_resource.level = level
      temp_resource.lob = lob
      newResources.push(temp_resource)
      newMonths = []
    }
    return newResources
  }

  renderHeader = (year, month) => {
    return (
      <StickyMonth>
        <MonthHead>{`${month.substring(0, 3)} ${year}`}</MonthHead>
      </StickyMonth>
    )
  }

  renderDetail = (man_day, m, user_id, month_key, hide) => {
    const employees = get(this.props, 'employees', [])
    const user = find(employees, {
      _id: user_id,
    })
    const $resource_cost = get(this.props, '$resource_cost', [])
    const noneWMD = find(get($resource_cost[month_key], 'none_wmd'), (wmd) => {
      return wmd === user_id
    })
    const editResource = get(this.props, 'editResource')
    const findMonth = find(man_day, {
      month: `${m.year}-${moment().month(m.month).format('MM')}`,
    })

    if ((m.year !== '' && m.month !== '') || (m.year === '' && m.month !== '')) {
      return (
        <DivInput>
          { !hide && <LevelName>{ man_day[month_key].level }</LevelName> }
          <InputWrapper>
          <NumberField
            name="man_days"
            disabled={ !editResource }
            value={findMonth.days}
            allowEmptyFormatting={true}
            thousandSeparator={true}
            decimalScale={2}
            fixedDecimalScale={true}
            invalid={findMonth.days > 31 ? 'true' : 'false'}
            noneWMD={ noneWMD ? 'true' : 'false' }
            onChange={(e) => {
              e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
              this.props.handleChangeCostResource(e, user_id, month_key)
            }}
          />
          { noneWMD &&
          <span
            style={ {
              background:`url(${WarningIcon}) no-repeat scroll 5px 5px`,
              position: 'absolute',
              left: 15,
              width: 25,
              height: 25,
            } }
          /> }
          <div className='tooltip'>
            { `Unable to find the cost and price of ${get(user, 'first_name')} ${get(user, 'last_name')} (${get(user, 'nick_name')}) in ${m.month} ${m.year}` }
          </div>
          </InputWrapper>
        </DivInput>
      )
    }
    return null
  }

  renderName = (resource, id) => {
    const hide = get(this.props, 'hide')
    const handleChangeCostResource = get(this.props, 'handleChangeCostResource')
    const deleteResource = get(this.props, 'deleteResource')
    const editResource = get(this.props, 'editResource')
    const employees = get(this.props, 'employees', [])
    const user = find(employees, {
      _id: resource.user_id,
    })
    let name,nickname = ''
    // let level = ''
    if (user) {
      name = `${user.first_name} ${user.last_name}`
      nickname = `(${user.nick_name})`
      // level = user.level
    }
    return (
      <StickyCol>
        <RowNum noGutters>
          <ColNum md={3}>
          <RowNormal noGutters>
            <TextLabel>Type</TextLabel>
          </RowNormal>
          <RowNormal noGutters>
            <DataText>{resource.type}</DataText>
          </RowNormal>
          </ColNum>
          <ColNum md={2}>
          <RowNormal noGutters>
            <TextLabel>LOB</TextLabel>
          </RowNormal>
          <RowNormal noGutters>
            <DataText>{get(user, 'lob')}</DataText>
          </RowNormal>
          </ColNum>
          <ColNum md={6}>
          <RowNormal noGutters>
            <TextLabel >Name</TextLabel>
          </RowNormal>
          <RowNormal noGutters>
            <NameText>{name}</NameText><NicknameText>{nickname}</NicknameText>
          </RowNormal>
          </ColNum>
          <ColNum md={1}>
            <Trash
              onClick={
                editResource ?
                  () => deleteResource(id)
                  : () => { }
              }
              edit={ editResource }
            />
          </ColNum>
        </RowNum>
        { resource.type !== 'Subcontract' &&
          <RowNum noGutters style={{ display: hide ? 'none' : 'flex' }}>
            <ColNum md={ 12 }>
            <RowNormal noGutters>
              <TextRole >Role</TextRole>
            </RowNormal>
            <RowNormal noGutters>
              <InputFieldRole
                name='role'
                disabled={ !editResource }
                defaultValue={resource.role}
                onBlur={(e) => handleChangeCostResource(e, id)}
              />
            </RowNormal>
            </ColNum>
            {/* <ColNum md={ 6 }>
            <RowNormal noGutters>
              <TextRole >Module</TextRole>
            </RowNormal>
            <RowNormal noGutters>
              <InputFieldRole
                name='module'
                disabled={ !editResource }
                defaultValue={resource.module}
                onBlur={(e) => handleChangeCostResource(e, id)}
              />
            </RowNormal>
            </ColNum> */}
            {/* <ColNum>
            <RowNormal noGutters>
              <TextLabel >Level</TextLabel>
            </RowNormal>
            <RowNormal noGutters>
              <DataText>{level}</DataText>
            </RowNormal>
            </ColNum> */}
          </RowNum>
        }
        { resource.type === 'Subcontract' &&
          <RowNum noGutters style={{ display: hide ? 'none' : 'flex' }}>
            <ColNum md={ 12 }>
            <RowNormal noGutters>
              <TextRole >Role</TextRole>
            </RowNormal>
            <RowNormal noGutters>
              <InputFieldRole
                name='role'
                disabled={ !editResource }
                defaultValue={resource.role}
                onBlur={(e) => handleChangeCostResource(e, id)}
              />
            </RowNormal>
            </ColNum>
            {/* <ColNum md={ 6 }>
            <RowNormal noGutters>
              <TextRole >Module</TextRole>
            </RowNormal>
            <RowNormal noGutters>
              <InputFieldRole
                name='module'
                disabled={ !editResource }
                defaultValue={resource.module}
                onBlur={(e) => handleChangeCostResource(e, id)}
              />
            </RowNormal>
            </ColNum> */}
          </RowNum>
        }
      </StickyCol>
    )
  }

  /* eslint no-underscore-dangle: 0 */
  render() {
    const { hideHeader } = this.props
    const hide = get(this.props, 'hide')
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && (rSelected === 1)
    const months = this.generateMonth(get(projectByID, 'start_date'), get(projectByID, 'end_date'))
    const resources = this.generateResource(months, !isPresale ? get(this.props, 'resources', []) : get(presale_snapshot, 'resources'))
    const $resource_cost = get(this.props, '$resource_cost', [])
    const $work_days = get(this.props, '$work_days', [])
    return (
      <WrapTable hide_header={ hideHeader }>
        { resources && $resource_cost && months.length > 0 &&
          <Sticky
            stickyHeaderCount={ hide ? 2 : 4 }
            stickyColumnCount={ 3 }
          >
              <FirstRow>
                <CellResource>Months</CellResource>
                <CellMD>
                  <StickyMonth>
                    <MonthHead>WMD</MonthHead>
                  </StickyMonth>
                </CellMD>
                <CellMD>
                  <StickyMonth>
                    <MonthHead>MD</MonthHead>
                  </StickyMonth>
                </CellMD>
                { months.map((item, i) => {
                    return (
                      <CellYear key={ shortid() }>
                        { this.renderHeader(item.year, item.month) }
                      </CellYear>)
                  })
                }
              </FirstRow>
              <Row>
                <CellHead>Working days available</CellHead>
                <CellHead/>
                <CellHead />
                { months.map((item, i) => {
                  const work_day = find($work_days, { month: `${item.year}-${moment(item.month, 'MMMM').format('MM')}` })
                    if ((item.year !== '' && item.month !== '') || (item.year === '' && item.month !== '')) {
                      return (
                        <CellMonth key={ shortid() }>
                          { get(work_day, 'days', '0.00').toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
                        </CellMonth>
                      )
                    } return <CellMonth key={ shortid() } />
                  })
                }
              </Row>
              <LastRow>
                <CellHeadLast style={{ display: hide ? 'none' : '' }}>Total Man-Days</CellHeadLast>
                <CellHeadLast style={{ display: hide ? 'none' : '' }} />
                <CellHeadLast style={{ display: hide ? 'none' : '' }} />
                { months.map((item, i) => {
                    if ((item.year !== '' && item.month !== '') || (item.year === '' && item.month !== '')) {
                      return (
                        <CellMonthLast key={ shortid() } style={{ display: hide ? 'none' : '' }}>
                          { get($resource_cost[i], 'man_days', '0.00').toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
                        </CellMonthLast>)
                    } return <CellMonthLast key={ shortid() } style={{ display: hide ? 'none' : '' }}/>
                  })
                }
              </LastRow>
              <LastRow>
                <CellHeadLast style={{ display: hide ? 'none' : '' }}>Total Weighted Man-Days</CellHeadLast>
                <CellHeadLast style={{ display: hide ? 'none' : '' }} />
                <CellHeadLast style={{ display: hide ? 'none' : '' }} />
                { months.map((item, i) => {
                    if ((item.year !== '' && item.month !== '') || (item.year === '' && item.month !== '')) {
                      return (
                        <CellMonthLast key={ shortid() } style={{ display: hide ? 'none' : '' }}>
                          { get($resource_cost[i], 'wmd', '0.00').toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
                        </CellMonthLast>)
                    } return <CellMonthLast key={ shortid() } style={{ display: hide ? 'none' : '' }}/>
                  })
                }
              </LastRow>
            <RowStick>
              <CellStick />
              <CellStick />
              <CellStick />
              { months.map((item, i) => {
                  if ((item.year !== '' && item.month !== '') || (item.year === '' && item.month !== '')) {
                    return <CellStick key={ shortid() } />
                  } return <CellStick key={ shortid() } />
                })
              }
            </RowStick>
            { resources.filter(this.filterResource).map((r, resource_key) => {
                return (
                  <Row key={ shortid() }>
                    <CellName key={ shortid() } hide={ resource_key % 2 === 0 ? 'true' : 'false'}>
                      {this.renderName(r, r.user_id)}
                    </CellName>
                    <CellSum
                      key={ shortid() }
                      hide={ resource_key % 2 === 0 ? 'true' : 'false'}
                      style={ {
                        fontFamily: 'Gotham',
                        textAlign: 'center',
                        fontSize: 14,
                      } }
                    >
                      { parseFloat(r.sumWeightManDays).toFixed(2) }
                    </CellSum>
                    <CellSum
                      key={ shortid() }
                      hide={ resource_key % 2 === 0 ? 'true' : 'false'}
                      style={ {
                        fontFamily: 'Gotham',
                        textAlign: 'center',
                        fontSize: 14,
                      } }
                    >
                      { parseFloat(r.sumManDays).toFixed(2) }
                    </CellSum>
                    { months.map((m, month_key) => {
                        return (
                          <CellDetail
                            key={ shortid() }
                            hide={ resource_key % 2 === 0 ? 'true' : 'false'}
                            bg={ m.month }
                          >
                            {this.renderDetail(r.man_days, m, r.user_id, month_key, hide)}
                          </CellDetail>     
                        )
                      })
                    }
                  </Row>
                )
              }
              )
            }
          </Sticky>
        }
      </WrapTable>
    )
  }
}

const CellName = styled(Cell)`
  background-color: '#fff';
  height: 100%;
`
const CellDetail = styled(Cell)`
  /* background-color: ${p => (p.bg !== '' ? '#F6EBEB' : '')}; */
  border-bottom: 1px solid #EEEEEE;
  vertical-align: middle;
  border-right: solid 1px #EEEEEE;
  min-width: 100px !important;
  max-width: 100px !important;
`

const CellSum = styled(CellDetail)`
  background-color: #FFFFFF;
`
const RowStick = styled(Row)`
  display:none;
`
const FirstRow = styled(Row)`
  background-color:#D44B49;
  color:#ffffff;
`
const LastRow = styled(Row)`
  -webkit-box-shadow:0px 1px 1px #F1F1F1;
  -moz-box-shadow:0px 1px 1px #F1F1F1;
  box-shadow:0px 1px 1px #F1F1F1;
`
const CellStick = styled(Cell)`
  display:none;
`
const CellYear = styled(Cell)`
  min-width: 100px !important;
  width: 100px !important;
  background-color:#D44B49;
  color:#ffffff;
  text-align: right;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  padding-top: 5px;
  border-right: solid 1px #EEEEEE;
`
const CellMD = styled(CellYear)`
  min-width: 100px !important;
  width: 100px !important;
`
const Sticky = styled(StickyTable)`
 padding-top: 0px !important;
 padding-right: 0px !important;
 padding-left: 0px !important;
 padding-bottom: 11px !important;
  .y-scrollbar {
    height: 100% !important;
    top: 0 !important;
    ::-webkit-scrollbar {
      -webkit-appearance: none;
    }
    ::-webkit-scrollbar:vertical {
      width: 11px;
    }
    ::-webkit-scrollbar:horizontal {
      height: 11px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 2px solid white; /* should match background, can't be transparent */
      background-color: rgba(0, 0, 0, .5);
    }
  }
  .x-scrollbar {
    ::-webkit-scrollbar {
      -webkit-appearance: none;
    }
    ::-webkit-scrollbar:vertical {
      width: 11px;
    }
    ::-webkit-scrollbar:horizontal {
      height: 11px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 2px solid white; /* should match background, can't be transparent */
      background-color: rgba(0, 0, 0, .5);
    }
  }
`
const CellHeadLast = styled(Cell)`
  border-bottom: solid 1px #EEEEEE;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  background-color: #FFFFFF ;
  padding-left: 10px;
  padding-top: 8px;
  border-right: solid 1px #EEEEEE;
`
const CellHead = styled(Cell)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  background-color: #FFFFFF ;
  padding-left: 10px;
  padding-top: 8px;
  border-bottom: solid 1px #EEEEEE;
  border-right: solid 1px #EEEEEE;
`
const CellResource = styled(Cell)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  height: 25px !important;
  min-width: 350px;
  padding-left: 10px;
  padding-top:5px;
  background-color: #D44B49;
  color:#ffffff;
  border-right: solid 1px #EEEEEE;
`
const CellMonth = styled(Cell)`
  text-align: right;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 3px;
  background-color: #FFFFFF ;
  border-bottom: solid 1px #EEEEEE;
  border-right: solid 1px #EEEEEE;
`
const CellMonthLast = styled(Cell)`
  border-bottom: solid 1px #EEEEEE;
  text-align: right;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 3px;
  background-color: #FFFFFF;
  border-right: solid 1px #EEEEEE;
`
const MonthHead = styled.div`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  width: 100% ;
  text-align: right;
  padding-right: 3px ;
`
const WrapTable = styled.div`
  position: relative;
  width: 100%;
  height: ${p => (p.hide_header ? 'calc(100vh - 220px)' : 'calc(100vh - 320px)')};
  overflow-y: hidden;
  border: solid 1px #EEEEEE;
`
const DivInput = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: center;

  span {
    white-space: nowrap;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    line-height: 40px;
    pointer-events:none;
  }

  span:after {
    content:"";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events:initial;
  }

  .tooltip {
    position: absolute;
    width: 300px;
    font-size: 12px;
    top: -10px;
    right: -250px;
    background-color: #fff;
    padding: 5px;
    -webkit-box-shadow: 0 1px 3px 0 rgba(0,0,0,0.3);
    transition: opacity 0s ease;
    opacity: 0;
    display: none;
  }

  span:hover + .tooltip,
  .tooltip:hover {
    transition: opacity 0s ease;
    transition-delay: 1s;
    opacity: 1;
    display: block;
  }
`
const StickyCol = styled.div`
  border-right: solid 1px #EEEEEE;
  border-left: solid 1px #EEEEEE;
  border-bottom: solid 1px #EEEEEE;
  padding-top:3px;
  width: 350px;
`
const StickyMonth = styled.div`
  background-color:#D44B49;
  color: #ffffff;
`
const DataText = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin: auto;
  margin-left:0px !important;
`
const NameText = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin: auto;
  margin-left:0px !important;
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`
const NicknameText = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin: auto;
  margin-left:0px !important;
  width: 30%;
`
const RowNum = styled(RowNormal)`
  padding-top: 0px;
  padding-bottom: 3px;
`
const ColNum = styled(Col)`
  padding-left: 10px !important;
  padding-right: 0px !important;
`
const TextLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM} !important;
  margin-bottom: 0px;
  font-size: 8px;
`
const TextRole = styled(Label)`
  font-family: ${FONTS.GOTHAM} !important;
  margin-bottom: 0px;
  font-size: 8px;
`
const InputFieldRole = styled(Input)`
  font-family: ${FONTS.GOTHAM} !important;
  width : 90%;
  height : 22px ;
  font-size: ${FONTS.SMALL_SIZE};
  margin-bottom: 3px;
`
const NumberField = styled(NumberFormat)`
  font-family: ${FONTS.GOTHAM} !important;
  text-align: right;
  width: 80%;
  font-size: ${FONTS.SMALL_SIZE};
  margin-left: 10% ;
  padding-left: ${props => { return props.noneWMD === 'true' ? '30px' : '0px' }};
  border-radius: 5px;
  border: ${props => { return props.invalid === 'true' ? '1px solid red' : '1px solid #CCCCCC' }};
  background-color: ${props => {
  const status = props.disabled
  if (status === !get(this.props, 'edit_resource')) {
    return '#E8ECEF'
  }
    return '#FFFFFF'
  }};
`
const Trash = styled.div`
  background-image: ${props => {
  const edited = props.edit
  if (edited) {
    return `url(${TrashHover})`
  }
  return `url(${TrashDefault})`
}};
  background-repeat: no-repeat;
  align-self: center;
  border:0;
  width: 15px ;
  height: 15px ;
  margin-top: 15px;
  margin-right: 15px;
  cursor: ${props => { return props.edit ? 'pointer' : 'default' }};
  float: right;
`

const LevelName = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: 10px;
  color: #D44B49;
  margin: 0 0 8px 0;
`

const InputWrapper = styled.div`
  position: relative;
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-resource-cost/index.js